import React from "react";
import { Box, TableCell, TableRow, Skeleton } from "@mui/material";

const BannerSkeleton = () => {
  return (
    <>
      <TableRow component={`tr`}>
        <TableCell style={{ textAlign: "center" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Skeleton variant="rectangular" width={20} height={20} />
          </Box>
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <Skeleton
            variant="rectangle"
            sx={{ height: "80px", width: "180px", borderRadius: "14px" }}
          />
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <Box
            sx={{
              display: "flex",
              gap: "5px",
              justifyContent: "start",
            }}
          >
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              sx={{ borderRadius: "8px" }}
            />
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              sx={{ borderRadius: "8px" }}
            />
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              sx={{ borderRadius: "8px" }}
            />
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};

export default BannerSkeleton;
